import { Navigate } from 'react-router-dom'
import { useAdminAuth } from '../../hooks/useAdminAuth'
import { LoadingSpinner } from '../../shared/components/ui/LoadingSpinner'

/**
 * Landing for /reports.
 *
 * An administrator comes here to produce reports, so the panel opens on
 * Generation. A district comes to read what was issued, so it opens on the
 * list. The list itself lives at /reports/flowmeter so the admin's Reports
 * link has somewhere to go that is not this redirect.
 *
 * Admin status resolves asynchronously. Deciding before it has would send an
 * administrator to the list, so this waits, as AdminProtectedRoute does.
 */
export default function ReportsIndex() {
  const { isAdmin, isLoading } = useAdminAuth()
  if (isLoading) return <LoadingSpinner />
  return <Navigate to={isAdmin ? '/reports/flowmeter/generation' : '/reports/flowmeter'} replace />
}
